/**
 * Componente: wa-buy
 * Descripción: Funcionalidad JavaScript para el botón/nota de WhatsApp
 * Autor: Sistema de componentes modular
 */

class WaBuy {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.trackAnalytics();
  }

  /**
   * Vincula eventos a los elementos del componente
   */
  bindEvents() {
    const waNotes = document.querySelectorAll('.wa-note');
    
    waNotes.forEach(note => {
      // Evento de click para tracking
      note.addEventListener('click', (e) => {
        this.handleClick(e, note);
      });

      // Evento de hover para analytics
      note.addEventListener('mouseenter', (e) => {
        this.handleHover(e, note);
      });
    });
  }

  /**
   * Maneja el evento de click
   * @param {Event} e - Evento de click
   * @param {HTMLElement} element - Elemento clickeado
   */
  handleClick(e, element) {
    const isLink = element.tagName === 'A';
    const newTab = element.dataset.newtab === 'true';
    
    // Tracking de analytics si está disponible
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'WhatsApp Button',
        event_label: isLink ? 'Link Click' : 'Button Click',
        value: 1
      });
    }

    // Si es un enlace y debe abrirse en nueva pestaña, no hacer nada más
    if (isLink && newTab) {
      return;
    }

    // Si no es un enlace, podrías agregar funcionalidad adicional aquí
    if (!isLink) {
      console.log('WhatsApp note clicked (no link)');
    }
  }

  /**
   * Maneja el evento de hover
   * @param {Event} e - Evento de hover
   * @param {HTMLElement} element - Elemento hovereado
   */
  handleHover(e, element) {
    // Tracking de hover si es necesario
    if (typeof gtag !== 'undefined') {
      gtag('event', 'hover', {
        event_category: 'WhatsApp Button',
        event_label: 'Button Hover',
        value: 1
      });
    }
  }

  /**
   * Configura tracking de analytics
   */
  trackAnalytics() {
    // Aquí puedes agregar configuración adicional de analytics
    console.log('WaBuy: Analytics tracking initialized');
  }

  /**
   * Método público para actualizar el componente dinámicamente
   * @param {Object} options - Opciones de configuración
   */
  update(options = {}) {
    const waNotes = document.querySelectorAll('.wa-note');
    
    waNotes.forEach(note => {
      if (options.bg) {
        note.style.setProperty('--wa-bg', options.bg);
      }
      if (options.fg) {
        note.style.setProperty('--wa-fg', options.fg);
      }
      if (options.size) {
        note.style.setProperty('--wa-size-d', options.size + 'px');
      }
    });
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  window.waBuy = new WaBuy();
});

// Exportar para uso en módulos
if (typeof module !== 'undefined' && module.exports) {
  module.exports = WaBuy;
}
